
<template>
  <div ref="container" class="d-flex flex-fill" v-if="show">
    <div v-if="mode === 'view'">{{ model?model.title:"-" }}</div>
    <div v-if="mode === 'edit' || mode === 'create'" class="d-flex flex-fill">
      <div class="input-group d-flex flex-fill">
        <div class="input-group-prepend custom" id="add-account" @click="openAccountTitleTree">
          <div class="input-group-text">
            <span>+</span>
          </div>
        </div>
        <vs-select
          ref="selectAccount"
          :isHeader="true"
          :data="accountsTitlesList"
          :selectedVal="model"
          :header="{label:'title'}"
          :mode="'edit'"
          v-model="account"
          @onChange="onValueChanged"
        ></vs-select>
      </div>
    </div>
    <!-- <b-modal ref="accountsModal" title="انتخاب حساب" size="lg" ok-only ok-title="تایید">
    </b-modal>-->
  </div>
</template>

<script>
import AccountsTitlesModal from "../components/AccountsTitlesModal.vue";
import Vue from "vue";
import VsSelect from "../_framework/VsSelect";
import BaseService from "../_framework/api/BaseService.js";
import JQuery from "jquery";
import EventBus from "../_framework/bus.js";

export default {
  name: "account-title-select",
  props: {
    data: null,
    header: null,
    headerKey: null,
    mode: null,
    placeholder: null,
    type: null,
    row: null
  },
  components: {
    AccountsTitlesModal,
    VsSelect
  },
  data() {
    return {
      show: true,
      allData: [],
      account: null,
      accountsTitles: [],
      model: null,
      lastValue: "",
      journals: [],
      _accountTitle: null
    };
  },
  methods: {
    setModel(accountTitle) {
      let _accountTitle = this._accountTitle || accountTitle;
      if (this.mode !== "create" && _accountTitle) {
        this.model = JSON.parse(JSON.stringify(_accountTitle));
        this.model.title = _accountTitle.code + " " + _accountTitle.title;
      }
      this.show = false;
      setTimeout(() => {
        this.show = true;
      }, 50);
    },
    openAccountTitleTree() {
      let accountsTitlesModal = Vue.extend(AccountsTitlesModal);
      let modal = new accountsTitlesModal({});
      let model = null;
      modal.$mount();
      this.$refs.container.appendChild(modal.$el);
      modal.openModal();
      setTimeout(() => {
        modal.openModal();
      }, 500);
      modal.$on("selectAccountTitle", data => {
        model = JQuery.extend({}, data);
        model.title = data.code + " " + data.title;
      });
      modal.$on("dblSelectAccountTitle", (data, ancestors) => {
        model = JQuery.extend({}, data);
        model.ancestors = ancestors;
        model.title = data.code + " " + data.title;
      });
      modal.$on("onOk", () => {
        if (model) {
          this.model = model;
        }
        // this.onValueChanged(this.model);
      });
    },
    findById(id) {
      let item = this.allData.find(d => {
        return d.id === id;
      });
      return item;
    },
    onValueChanged(val) {
      if (val) {
        let pId = val.parentId;
        let ancestors = [];
        while (pId) {
          let node = this.findById(pId);
          ancestors.push(node);
          pId = node.parentId;
        }
        val.ancestors = ancestors;
      }
      this.$emit("dataChanged", this.headerKey, val);
      EventBus.$emit("onSelectAccountTitle", val);
    },
    onKeyDown(event) {
      if (this.type === "number" && event.key === "e") {
        event.preventDefault();
        return;
      }

      this.$nextTick(() => {
        if (event.target.value === this.lastValue) {
          return;
        }

        this.onValueChanged(event.target.value);
        this.lastValue = event.target.value;
      });
    }
  },
  computed: {
    accountsTitlesList() {
      let list = this.accountsTitles;
      list.map(a => {
        a.title = a.code + " " + a.title;
      });
      return list;
    },
    value() {
      if (
        this.header.formatCurrency !== undefined &&
        this.header.formatCurrency
      ) {
        return this.$options.filters.formatCurrency(this.data);
      }

      if (
        this.header.formatGregorianDateToJalaali !== undefined &&
        this.header.formatGregorianDateToJalaali
      ) {
        return this.$options.filters.formatGregorianDateToJalaali(this.data);
      }

      return this.data.title;
    }
  },
  mounted() {
    let code = this.data && this.data.split ? this.data.split(" ")[0] : 0;
    if (this.$route.query.id) {
      new BaseService("AccountingVouchers")
        .getById(this.$route.query.id)
        .then(rs => {
          this.journals = rs.data.journals;
          rs.data.journals.map(j => {
            if (j.accountTitle.code === code) {
              this._accountTitle = j.accountTitle;
              this.setModel(j.accountTitle);
            }
          });
        });
    }
    if (this.mode === "create") {
      this.model = null;
    }
    new BaseService("accounttitle").getAll({ accountType: 3 }).then(rs => {
      this.accountsTitles = rs.data;
    });
    new BaseService("accounttitle").getAll().then(rs => {
      this.allData = rs.data;
      if (this.mode === "view") {
        rs.data.map(d => {
          if (d.code === code) {
            this._accountTitle = d;
            this.setModel(d);
          }
        });
      }
    });
  },
  watch: {
    mode(val) {
      this.setModel();
    },
    _accountTitle(val) {
      let _mode = this.mode;
      this.mode = null;
      this.mode = _mode;
    }
  }
};
</script>

<style scoped>
/* .input-group > div:not(.custom) {
  display: flex;
  flex: 1;
} */
/* .v-select .dropdown-toggle input {
  width: 100% !important;
}
.v-select > div {
  width: 100% !important;
} */
#add-account:hover {
  cursor: pointer;
}
</style>
